"use strict"

document.addEventListener('DOMContentLoaded', function () {
	
	let form = document.forms;

	for (form of document.forms) {
		form.addEventListener('submit', formSend);
	}
	
		async function formSend(e) {
	
			e.preventDefault();

			let error = formValidate(e.target);
			let formData = new FormData(e.target);

			if (error === 0) {
		    	e.target.classList.add('_sending');
				let response = await fetch('/CHINT-for-projector/', {
					method: 'POST',
					body: formData
				});
				if (response.ok) {
					// let result = await response.json();
					// alert(result.message);
					document.getElementById('popup').classList.add('open');
					e.target.reset();
					e.target.classList.remove('_sending');
				} else {
					alert("Ошибка");
					e.target.classList.remove('_sending');
				}
			} else {
				alert('Заполните обязательные поля');
			}
		}
	

	function formValidate(form) {
		let error = 0;
		
		let formReq = form.querySelectorAll('._req');

		for (let index = 0; index < formReq.length; index++) {
			const input = formReq[index];
			formRemoveError(input);

			if (input.classList.contains('_email')) {
				if (emailTest(input)) {
					formAddError(input);
					error++;
				}
			} 
			else if (input.classList.contains('_phone')) {
				if (phoneTest(input)) {
					formAddError(input);
					error++;
				}
			}else {
				if (input.value === '' || input.value === '42') {
					formAddError(input);
					error++;
				}
			}
		}
		return error;
	}

	function formAddError(input) {
		input.parentElement.classList.add('_error');
		input.classList.add('_error');
	}

	function formAddErrorSelect() {
		var select = document.getElementsByClassName("_city"); 
		select.classList.add('_error');

	}

	function formRemoveError(input) {
		input.parentElement.classList.remove('_error');
		input.classList.remove('_error');
	}
	//Функция теста email
	function emailTest(input) {
		return !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(input.value);
	}

	//функция теста phone
	function phoneTest(input) {
		return !/^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(input.value);
	}

});

